export default "__VITE_ASSET__cUsGpOAL__"